export default function generateCountries(paramData) {
    this.popup('generateCountries', {
        params: {
            way: paramData.way,
            module: paramData.module,
            id: paramData.id,
        },
        header: this.translate('LBL_GENERATE_COUNTRIES', paramData.module),
    });
}
